import React, { useContext, useMemo } from 'react'

import { FacilityAssignmentContext } from './DataContext'
import withConfig from '../../../../wrappers/withConfig'
import SaveButton from '../SaveButton'
import DataContext from '../../DataContext'

const Remove = ({ isSubmitting }) => {
    const {
        Remove,
        possibleFacilityData,
        highlightedPossibleFacilities,
    } = useContext(FacilityAssignmentContext)

    const isDisabled = useMemo(
        () =>
            isSubmitting ||
            (highlightedPossibleFacilities &&
                highlightedPossibleFacilities.length <= 0),
        [isSubmitting, possibleFacilityData, highlightedPossibleFacilities]
    )

    return (
        <div className="saveButtonWrapper">
            <button
                type={`button`}
                className={`button is-danger is-small`}
                disabled={isDisabled}
                onClick={Remove}
            >
                Remove
            </button>
        </div>
    )
}

const MakePrimary = ({ isSubmitting }) => {
    const {
        possibleFacilityData,
        highlightedPossibleFacilities,
        setAsPrimary,
    } = useContext(FacilityAssignmentContext)

    const isDisabled = useMemo(
        () =>
            isSubmitting ||
            (possibleFacilityData && possibleFacilityData.length <= 1) ||
            (highlightedPossibleFacilities &&
                (highlightedPossibleFacilities.length === 0 ||
                    highlightedPossibleFacilities.length > 1)),
        [isSubmitting, possibleFacilityData, highlightedPossibleFacilities]
    )

    return (
        <div className="saveButtonWrapper">
            <button
                type={`button`}
                className={`button is-primary is-small`}
                disabled={isDisabled}
                onClick={setAsPrimary}
            >
                Set as Primary Well
            </button>
        </div>
    )
}

export default withConfig(({ config, isSubmitting }) => {
    const { loadingPossibleFacilities } = useContext(FacilityAssignmentContext)
    return (
        <div className="field is-horizontal is-grouped is-grouped-centered formSubmitWrapper">
            <div className="control is-one-third">
                <Remove isSubmitting={isSubmitting} />
            </div>
            <div className="control is-one-third">
                <MakePrimary isSubmitting={isSubmitting} />
            </div>
            <div className="control is-one-third">
                <SaveButton
                    formId="assigned-facilities"
                    size="small"
                    extraDisabledCondition={loadingPossibleFacilities}
                />
            </div>
            {/* <ResetButton formId="assigned-facilities" /> */}
        </div>
    )
})
